import { CurrencyPhpIcon } from './CurrencyPhpIcon';

/**
 * author: Michael Richins
 * id 734CB783-C788-4F5E-BB90-BFBF4E3C22DC
 * name currency-php
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-php.svg
 * tags
 * - Banking 
 * - Currency 
 */
export const PhilippinePesoIcon = CurrencyPhpIcon;
export default PhilippinePesoIcon